import { render, staticRenderFns } from "./page_navbar.vue?vue&type=template&id=1b0bc251&scoped=true&"
import script from "./page_navbar.vue?vue&type=script&lang=coffee&"
export * from "./page_navbar.vue?vue&type=script&lang=coffee&"
import style0 from "./page_navbar.vue?vue&type=style&index=0&id=1b0bc251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bc251",
  null
  
)

export default component.exports